import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Logo, LanguageSwitcher } from "@/components/site/Logo";

export default function Header() {
  const { t } = useApp();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  const links = [
    { to: "/leistungen", label: t.nav.services },
    { to: "/projekte", label: t.nav.gallery },
    { to: "/ueber-uns", label: t.nav.about },
    { to: "/kontakt", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 border-b ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-slate-200" : "bg-white/0 border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className="text-sm font-semibold text-slate-600 hover:text-brand transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 w-0 h-0.5 bg-accent2 transition-all duration-300 group-hover:w-full" />
            </Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-5">
          <LanguageSwitcher />
          <Link
            to="/kontakt"
            data-testid="header-cta"
            className="bg-brand text-white text-sm font-semibold px-5 py-2.5 hover:bg-accent2 transition-colors"
          >
            {t.nav.quote}
          </Link>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-brand"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menü"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200" data-testid="mobile-menu">
          <div className="px-4 py-6 flex flex-col gap-1">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="py-3 text-lg font-display font-medium text-brand border-b border-slate-100">
                {l.label}
              </Link>
            ))}
            <div className="pt-4 flex items-center justify-between">
              <LanguageSwitcher />
              <Link to="/kontakt" className="bg-brand text-white text-sm font-semibold px-5 py-2.5">
                {t.nav.quote}
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
